import { InterceptedCoroutine142wh200e9wbr as InterceptedCoroutine } from '../InterceptedCoroutine.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../Standard.mjs';
import { GeneratorCoroutineImpl2pzxhv55we2g3 as GeneratorCoroutineImpl } from '../GeneratorCoroutineImpl.mjs';
import { SafeContinuation1x0fxyaxo6cwq as SafeContinuation } from '../SafeContinuationJs.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___get_isSuccess__impl__sndoy8mo1btlyt1vs as _Result___get_isSuccess__impl__sndoy8,
  Result__exceptionOrNull_impl_p6xea93txwfmg154xda as Result__exceptionOrNull_impl_p6xea9,
} from '../../Result.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../Unit.mjs';
import { EmptyCoroutineContext_instance3dshdbvg42f79 as EmptyCoroutineContext_instance } from '../CoroutineContextImpl.mjs';
import {
  startCoroutine1brije5juseye as startCoroutine,
  Continuation1aa2oekvx7jm7 as Continuation,
} from '../Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function intercepted(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4 instanceof InterceptedCoroutine() ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.bd();
  return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
}
function invokeSuspendSuperTypeWithReceiver(_this__u8e3s4, receiver, completion) {
  throw NotImplementedError().nd('It is intrinsic method');
}
function invokeSuspendSuperType(_this__u8e3s4, completion) {
  throw NotImplementedError().nd('It is intrinsic method');
}
function invokeSuspendSuperTypeWithReceiverAndParam(_this__u8e3s4, receiver, param, completion) {
  throw NotImplementedError().nd('It is intrinsic method');
}
function createCoroutineUninterceptedGeneratorVersion(_this__u8e3s4, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  var tmp = continuation;
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  tmp.vc_1 = typeof a === 'function' ? a(continuation) : _this__u8e3s4.od(continuation);
  return continuation;
}
function createCoroutineUninterceptedGeneratorVersion_0(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  var tmp = continuation;
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  tmp.vc_1 = typeof a === 'function' ? a(receiver, continuation) : _this__u8e3s4.pd(receiver, continuation);
  return continuation;
}
function startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var generator = typeof a === 'function' ? a(continuation) : _this__u8e3s4.od(continuation);
  continuation.vc_1 = generator;
  return continuation.yc();
}
function startCoroutineUninterceptedOrReturnGeneratorVersion_0(_this__u8e3s4, receiver, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var generator = typeof a === 'function' ? a(receiver, continuation) : _this__u8e3s4.pd(receiver, continuation);
  continuation.vc_1 = generator;
  return continuation.yc();
}
function startCoroutineUninterceptedOrReturnGeneratorVersion_1(_this__u8e3s4, receiver, param, completion) {
  // Inline function 'kotlin.coroutines.intrinsics.startCoroutineFromGeneratorFunction' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var continuation = new (GeneratorCoroutineImpl())(completion);
  // Inline function 'kotlin.js.asDynamic' call
  var a = _this__u8e3s4;
  var generator = typeof a === 'function' ? a(receiver, param, continuation) : _this__u8e3s4.qd(receiver, param, continuation);
  continuation.vc_1 = generator;
  return continuation.yc();
}
function *await_0(promise, $completion) {
  // Inline function 'kotlin.coroutines.suspendCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var c = $completion;
    var safe = SafeContinuation().id(intercepted(c));
    var continuation = safe;
    var tmp = (result) => {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(result);
      this_0.sc(tmp$ret$5);
      return Unit_instance;
    };
    promise.then(tmp, (error) => {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(error));
      this_0.sc(tmp$ret$7);
      return Unit_instance;
    });
    return safe.jd();
  };
}
function promisify(fn) {
  return new Promise((resolve, reject) => {
    // Inline function 'kotlin.coroutines.Continuation' call
    var completion = new (promisify$1$$inlined$Continuation$1())(EmptyCoroutineContext_instance, resolve, reject);
    startCoroutine(fn, completion);
    return Unit_instance;
  });
}
var promisify$1$$inlined$Continuation$1Class;
function promisify$1$$inlined$Continuation$1() {
  if (promisify$1$$inlined$Continuation$1Class === VOID) {
    class $ {
      constructor($context, $resolve, $reject) {
        this.rd_1 = $context;
        this.sd_1 = $resolve;
        this.td_1 = $reject;
      }
      qc() {
        return this.rd_1;
      }
      rc(result) {
        // Inline function 'kotlin.onSuccess' call
        var action = this.sd_1;
        if (_Result___get_isSuccess__impl__sndoy8(result))
          action(_Result___get_value__impl__bjfvqg(result));
        // Inline function 'kotlin.onFailure' call
        var action_0 = this.td_1;
        var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(result);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          action_0(tmp0_safe_receiver);
        }
        return Unit_instance;
      }
      sc(result) {
        return this.rc(result);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [Continuation()]);
    promisify$1$$inlined$Continuation$1Class = $;
  }
  return promisify$1$$inlined$Continuation$1Class;
}
//region block: exports
export {
  await_0 as await3n7kedgocftsv,
  createCoroutineUninterceptedGeneratorVersion as createCoroutineUninterceptedGeneratorVersion1ji2no4l6ift5,
  createCoroutineUninterceptedGeneratorVersion_0 as createCoroutineUninterceptedGeneratorVersion2gduom218i9ay,
  intercepted as intercepted2ogpsikxxj4u0,
  promisify as promisify1z0ncraq1ipzh,
  startCoroutineUninterceptedOrReturnGeneratorVersion_0 as startCoroutineUninterceptedOrReturnGeneratorVersion1cv0wx9z0l0zn,
  startCoroutineUninterceptedOrReturnGeneratorVersion_1 as startCoroutineUninterceptedOrReturnGeneratorVersion36jld8bkc4ba2,
  startCoroutineUninterceptedOrReturnGeneratorVersion as startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4,
};
//endregion

//# sourceMappingURL=IntrinsicsJs.mjs.map
